import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid} from '@mui/material';
import Field from 'core/oms/Field';
import FieldView from 'core/components/layout/FieldView';
import ProductInfoImpl from '../../ProductInfoImpl';
import ViewproductDetails from './ViewproductDetails';

export default function ViewproductActionImpl(){
  const {productObj} = useSelector((state)=>state.pharmaslice.productDashboard);
    return (
        
          <ViewproductDetails/>
     
    )
}